import { userConstants } from "../_constants";
import { userService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";

export const userActions = {
  login,
  logout,
  getAuthenticatedUserData
};

function login(username, password, pathname) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(function(value) {
      if (value.token) {
        dispatch(userService.getAuthenticatedUser(value.token)).then(results => {
          const user = {
            ...value,
            ...results
          };

          dispatch(success(user));
          if (pathname) {
            history.push(pathname.from);
          } else {
            history.push("/");
          }
        });
      } else {
        const error = value;
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    });
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getAuthenticatedUserData(userData) {
  return { type: userConstants.GET_AUTHENTICATED_USER_DATA, userData };
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js